<template>
  <div>
    <div class="all-lb" style="display: flex" ref="tabRef">
      <div class="total-m">
        <div class="list-header">
          <span>问题反馈</span>
          <el-button @click="eoistolizeDialog = true" style="color: #33353e"
            >提交反馈</el-button
          >
          <el-dialog
            title="问题反馈"
            class="eoistolizeDialog"
            :visible.sync="eoistolizeDialog"
            width="720px"
            :before-close="handleClose"
            append-to-body
          >
            <el-form
              :model="eoistolizForm"
              :rules="rules"
              ref="eoistolizForm"
              label-width="54px"
            >
              <el-form-item label="主题" prop="subject">
                <el-input
                  v-model="eoistolizForm.subject"
                  placeholder="请输入主题"
                ></el-input>
              </el-form-item>
              <el-form-item label="内容" class="textarea-item" prop="textarea">
                <el-input
                  type="textarea"
                  placeholder="请详细说明，以便我们解决问题……"
                  v-model="eoistolizForm.textarea"
                  maxlength="500"
                  show-word-limit
                  class="textarea"
                  style=" 100%"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="eoistolizeDialog = false">取 消</el-button>
              <el-button type="primary" @click="listSubmit('eoistolizForm')"
                >提交</el-button
              >
            </div>
          </el-dialog>
        </div>
        <div class="total-list">
          <el-table
            :data="tableData"
            style="width: 100%"
            class="detailTable"
            :row-class-name="tableRowClassName"
          >
            <el-table-column prop="date" label="内容" width="807px">
              <template slot-scope="scope">
                <div class="question-content">
                  <span class="subject"> 主题：{{ scope.row.subject }} </span>
                  <span
                    class="reply"
                    @click="detailClick(scope.row.questionId)"
                  >
                    内容：{{ scope.row.reply }}
                  </span>
                  <!-- 点击内容跳转详情  :before-close="handleClose"-->
                  <el-dialog
                    title="问题反馈"
                    class="replayDialog"
                    :visible.sync="detailDialog"
                    width="720px"
                    append-to-body
                  >
                    <el-form
                      :model="questionsForm"
                      :rules="rules"
                      ref="replayForm"
                      label-width="68px"
                    >
                      <el-form-item label="反馈时间" prop="">
                        <el-input v-model="questionsForm.createTime"></el-input>
                      </el-form-item>
                      <el-form-item label="主题" prop="replyContent">
                        <el-input v-model="questionsForm.subject"></el-input>
                      </el-form-item>
                      <el-form-item class="textarea-item" label="反馈内容">
                        <el-input
                          disabled
                          type="textarea"
                          v-model="questionsForm.content"
                          maxlength="500"
                          show-word-limit
                          class="textarea"
                          style=" 100%"
                        >
                        </el-input>
                      </el-form-item>

                      <el-form-item
                        v-if="questionsForm.isFix == true"
                        class="textarea-reply"
                        label="回复内容"
                        style="display: flex"
                      >
                        <el-input
                          disabled
                          type="textarea"
                          v-model="questionsForm.reply"
                          maxlength="500"
                          show-word-limit
                          class="textarea"
                          style=" 100%"
                        >
                        </el-input>
                      </el-form-item>
                      <el-form-item class="textarea-error" label="" v-else>
                        <el-input
                          disabled
                          show-word-limit
                          v-model="aaaa"
                          placeholder="反馈暂时没有得到处理，请耐心等待……"
                          class="textarea"
                          style=" 100%"
                        ></el-input>
                      </el-form-item>
                    </el-form>
                  </el-dialog>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="日期"
              width="193px"
              align="right"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageParams.currentPage"
          background
          layout="sizes, prev, pager, next"
          :page-count="pageParams.pageCount"
          :page-sizes="[5, 10, 20, 50, 100]"
          :page-size="pageParams.pageSize"
        >
        </el-pagination>
      </div>
    </div>
    <div class="all-lb">
      <div class="total-m" style="display: none" ref="nullRef">
        <div class="default-page">
          <div class="default-entrance">
            <img src="../assets/img/rtaLogo/default-page.svg" alt="" />
            <span>没有反馈记录</span>
            <el-button @click="eoistolizeDialog = true">反馈问题</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getQuestionsSubmit,
  sendQuestionList,
  getQuestionSubmit,
} from '@/api/message.js';
export default {
  components: {},
  data() {
    return {
      pageParams: {
        pageIndex: 1,
        pageSize: 10,
        total: 20,
        pageCount: 3,
      },
      tableData: [],
      //提交反馈对话框
      eoistolizeDialog: false,
      detailDialog: false,
      eoistolizForm: {
        subject: '',
        textarea: '',
      },
      questionsForm: {
        createTime: '',
        subject: '',
        content: '',
        reply: '',
        isFix: false,
      },
      rules: {
        subject: [{ required: true, message: '请填写主题', trigger: 'blur' }],
        textarea: [
          { required: true, message: '请填写反馈内容', trigger: 'blur' },
        ],
      },
      aaaa: '',
    };
  },
  created() {
    this.getQuestionData();
  },
  mounted() {},
  methods: {
    //判断是否有回复isFix=trueshi
    tableRowClassName({ row, rowIndex }) {
      if (!row.isFix) {
        //console.log('已回复', row);
        return 'warning-row';
      }
      return '';
    },
    //获取所有提交的数据
    async getQuestionData() {
      let params = {
        pageIndex: this.pageParams.pageIndex,
        pageSize: this.pageParams.pageSize,
      };
      const { data: res } = await getQuestionsSubmit(params);
      if (res.data.length == 0) {
        this.$refs.tabRef.style.display = 'none';
        this.$refs.nullRef.style.display = 'flex';
      } else {
        this.$refs.tabRef.style.display = 'flex';
        this.$refs.nullRef.style.display = 'none';
        let questions = res.data;
        //console.log('所有提交的问题', questions);
        this.pageParams.pageCount = res.pageCount;
        questions.forEach((item) => {
          this.timeArr = this.dateTypeFormat(
            'mm-dd HH:MM',
            new Date(item.createTime)
          );
          const questionObj = {
            subject: item.subject,
            reply: item.reply,
            createTime: this.timeArr,
            isFix: item.isFix,
            questionId: item.questionId,
          };
          this.tableData.push(questionObj);
          //console.log("所有提交的数据",this.tableData)
        });
      }
    },
    // 每页显示的记录数切换事件
    handleSizeChange(val) {
      this.pageParams.pageSize = val;
      this.getQuestionData();
      // console.log("每页及记录-->", this.pageParams.pageSize);
    },
    // 切换页码事件
    handleCurrentChange(val) {
      this.pageParams.pageIndex = val;
      this.getQuestionData();
    },
    // //提交问题对话框
    handleClose(done) {
      this.$confirm('', '确认关闭？' ,{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: '',
          customClass: 'question-confirm',
        })
        .then((_) => {
          done();
          this.eoistolizForm.subject = '';
          this.eoistolizForm.textarea = '';
        })
        .catch((_) => {});
    },
    //提交反馈
    async listSubmit(formName) {
      let sendQuestionObj = {
        subject: this.eoistolizForm.subject,
        content: this.eoistolizForm.textarea,
      };
      //console.log('发送对象：', sendQuestionObj);
      const { data: res } = await sendQuestionList(sendQuestionObj);
      //console.log('返回内容：', res);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message('提交成功');
          this.eoistolizeDialog = false;
          this.eoistolizForm.subject = '';
          this.eoistolizForm.textarea = '';
        } else {
          this.$message.error('错了哦，请重新提交');
          return false;
        }
      });
    },
    //根据questionId 获取问题具体信息
    async getQuestionsData(id) {
      const { data: res } = await getQuestionSubmit({
        questionId: id,
      });
      this.questionsForm.createTime = this.dateTypeFormat(
        'YY-mm-dd HH:MM',
        new Date(res.data.createTime)
      );
      this.questionsForm.subject = res.data.subject;
      this.questionsForm.content = res.data.content;
      this.questionsForm.reply = res.data.reply;
      this.questionsForm.isFix = res.data.isFix;
    },
    // 点击私信列表获取详细信息
    detailClick(id) {
      this.questionsForm.createTime = '';
      this.questionsForm.subject = '';
      this.questionsForm.content = '';
      this.questionsForm.reply = '';
      this.questionsForm.isFix = false;
      //this.aaaa = '反馈暂时没有得到处理，请耐心等待……';
      this.getQuestionsData(id);
      this.detailDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.all-lb {
  width: 1200px;

  //text-align: center;
  //display: flex !important;
  flex-direction: column !important;
  margin: 0 auto;
  .el-table .warning-row {
    background: red !important;
  }
  .el-table {
    tbody tr:hover > td {
      background-color: rgba(255, 255, 255, 0.1) !important;
    }
  }
  .total-m {
    margin: 40px 100px;
    .list-header {
      width: 100%;
      height: 32px;
      margin-bottom: 24px;
      display: flex;
      justify-content: space-between;
      span {
        font-size: 24px;
        font-family: MicrosoftYaHei;
        color: #d1d4dc;
      }
      .el-button {
        padding: 0 !important;
        width: 88px;
        height: 32px;
        background: #edbd88;
        border-radius: 4px;
        border: none;
        span {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #33353e !important;
        }
      }
      .el-button:active {
        color: #33353e !important;
      }
      .el-button:focus,
      .el-button:hover {
        color: #33353e !important;
      }
    }
    .total-list {
      width: 100%;
      height: 100%;
      display: flex;
      background: rgba(159, 159, 159, 0.1);
      justify-content: space-between;
      background: #3e4048 !important;
      border-radius: 8px !important;
    }
    .default-page {
      margin: 65px 100px;
      text-align: center;
      margin: 0 auto;
      .default-entrance {
        margin: 148px 340px;
        display: flex;
        flex-direction: column;
        img {
          width: 320px;
          height: 220px;
        }
        span {
          width: 320px;
          margin-top: 32px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #d1d4dc;
          line-height: 19px;
        }
        .el-button {
          width: 320px;
          height: 40px;
          margin-top: 40px;
          background: #edbd88;
          border-radius: 4px;
          padding: 0;
          border: none;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #33353e;
          }
        }
        .el-button:active {
          color: #33353e;
        }
        .el-button:focus,
        .el-button:hover {
          color: #33353e;
        }
      }
    }
  }
}
</style>
<style lang="scss" >
.el-message-box__wrapper {
  .question-confirm {
    width: 384px;
    height: 108px !important;
    background: rgba(51, 53, 62, 1);
    border: none;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2),
      0px 6px 16px 0px rgba(22, 23, 28, 0.32),
      0px 3px 6px -4px rgba(51, 53, 62, 0.48);
    border-radius: 4px;
    padding-bottom: 0 !important;
    .el-message-box__header {
      padding: 16px 26px 25px 22px !important;
      height: 26px;
      .el-message-box__title {
        width: 320px !important;
        span {
          width: 64px;
          height: 24px;
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: rgba(255, 255, 255, 0.85);
          line-height: 24px;
        }
      }
      .el-message-box__headerbtn {
        top: 26px !important;
        right: 26px !important;
        .el-message-box__close {
        }
      }
    }
    .el-message-box__content {
      padding: 0 15px;
      .el-message-box__container {
        .el-message-box__message {
          p {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: rgba(255, 255, 255, 0.65);
            line-height: 22px;
          }
        }
      }
    }
    .el-message-box__btns {
      height: 24px !important;
      padding: 0 26px 16px 15px !important;
      .el-button {
        width: 49px;
        height: 24px;
        border-radius: 2px;
        background: #33353e;
        border: 1px solid rgba(255, 255, 255, 0.2);
        span {
          font-size: 13px;
          font-family: MicrosoftYaHei;
          color: rgba(255, 255, 255, 0.65);
        }
      }
      .el-button--primary {
        background: #edbd88;
        span {
          color: #33353e;
        }
      }
      .el-button--small {
        padding: 0;
      }
    }
  }
}
.el-table .warning-row {
  background: rgba(247, 82, 95, 0.1) !important;
}
.el-table,
.el-table__expanded-cell {
  background-color: transparent;
}

.el-table th,
.el-table tr {
  background-color: transparent;
}
.el-table__body tr:hover > td {
  background: rgba(255, 255, 255, 0.1) !important;
  color: #33353e;
}

.detailTable {
  .el-table__body tr:hover > td {
    background: rgba(255, 255, 255, 0.1) !important;
    color: #33353e;
  }
  .el-table__header-wrapper {
    display: none !important;
  }
  .el-table__body-wrapper {
    border-radius: 8px !important;
    background: transparent;
    .el-table__body {
      width: 1000px;
      tr {
        width: 100%;
        // background: #3e4048 !important;
        height: 84px;
        line-height: 84px;
        .el-table__cell {
          padding: 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          .cell {
            padding: 0;
            margin: 0 24px;
            .question-content {
              width: 100% !important;
              display: flex;
              flex-direction: column;
              span {
                width: 759px;
                font-size: 14px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                color: #d1d4dc;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .subject {
                font-weight: bold;
              }
            }
          }
        }
        .is-right {
          .cell {
            font-size: 14px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: rgba(209, 212, 220, 0.7);
          }
        }
      }
      .el-table__row {
        padding: 0 !important;
        margin: 0 !important;
      }
    }
  }
}
.pagination {
  // margin-top: 40px;
  text-align: center;
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    margin: 0 5px;
    background-color: rgba(61, 63, 72, 1) !important;
    color: #d1d4dc;
    min-width: 32px;
    min-height: 32px;
    border-radius: 2px;
  }
  .el-pagination {
    .el-pagination__sizes {
      .el-select {
        .el-input {
          .el-input__inner {
            height: 32px;
            border: none !important;
            background-color: rgba(61, 63, 72, 1) !important;
            color: #d1d4dc;
          }
        }
      }
    }
    .el-pager {
      li {
        padding: 4px 4px;
      }
    }
    .el-pager li:not(.disabled):hover {
      color: rgba(51, 53, 62, 1) !important;
      background: #edbd88 !important;
    }
    .el-pager li:not(.disabled).active {
      color: rgba(51, 53, 62, 1) !important;
      background: #edbd88 !important;
    }
  }
}
.eoistolizeDialog {
  .el-dialog {
    height: 612px;
    background: #33353e !important;
    border-radius: 8px;
    .el-dialog__header {
      height: 70px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .el-dialog__title {
        line-height: 71px;
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #d1d4dc;
        margin-left: 20px;
      }
    }
    .el-dialog__body {
      //   height: 100%;
      margin: 35px 20px 16px 20px;
      .el-form {
        .el-form-item {
          margin-bottom: 32px;
          .el-form-item__label {
            height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #d1d4dc;
            text-align: justify;
          }
          .el-form-item__label::after {
            content: ' ';
            width: 100%;
            display: inline-block;
          }
          .el-form-item__content {
            .el-input {
              .el-input__inner {
                background: rgba(255, 255, 255, 0.1) !important;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 0.6) !important;
                border: none;
              }
            }
            .textarea {
              height: 335px !important;
              .el-input__inner {
                height: 206px;
                overflow-y: auto;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #d1d4dc;
              }
              .el-input__suffix {
                .el-input__suffix-inner {
                  .el-input__count {
                    // display: inline-flex;
                    // align-items: flex-end;
                    .el-input__count-inner {
                      background: transparent;
                      font-size: 14px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #d1d4dc;
                      padding: 16px 16px;
                    }
                  }
                }
              }
            }
            .el-textarea {
              .el-textarea__inner {
                resize: none;
                height: 335px !important;
                overflow-y: auto;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
                max-height: 335px;
                min-height: 335px !important;
                padding: 12px 16px 16px 16px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #d1d4dc;
              }
              .el-input__count {
                background: transparent;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #d1d4dc;
              }
            }
          }
        }
        .textarea-item {
          .el-form-item__content {
            height: 335px !important;
            .textare {
              height: 335px !important;
            }
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 8px 20px 20px;
      .dialog-footer {
        .el-button {
          line-height: 32px !important;
          width: 72px;
          height: 32px !important;
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: rgba(51, 53, 62, 1);
          margin: 0 0 0 12px !important;
          padding: 0 !important;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #d1d4dc;
          }
        }
        .el-button--primary {
          background: #edbd88 !important;
          border: none;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #33353e;
          }
        }
      }
    }
  }
}
.replayDialog {
  .el-dialog {
    height: 600px !important;
    background: #33353e !important;
    border-radius: 8px;
    -webkit-box-shadow: none !important;
    .el-dialog__header {
      height: 70px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .el-dialog__title {
        line-height: 71px;
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #d1d4dc;
        margin-left: 20px;
      }
    }
    .el-dialog__body {
      height: 478px !important;
      margin: 35px 20px 16px 20px;
      //私信详情
      .el-form {
        .el-form-item {
          margin-bottom: 12px !important;
          .el-form-item__label {
            height: 20px !important;
            line-height: 20px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: rgba(209, 212, 220, 0.7);
            text-align: justify;
          }
          .el-form-item__label::after {
            content: ' ';
            width: 100%;
            //display: inline-block;
          }
          .el-form-item__content {
            .el-input {
              .el-input__inner {
                height: 20px !important;
                line-height: 20px;
                background: none !important;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 1);
                border: none;
              }
            }
            .textarea {
              height: 92px !important;
              .el-input__inner {
                height: 92px !important;
                overflow-y: auto;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
              }
              .el-input__suffix {
                .el-input__suffix-inner {
                  .el-input__count {
                    // display: inline-flex;
                    // align-items: flex-end;
                    .el-input__count-inner {
                      background: transparent;
                      font-size: 14px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #d1d4dc;
                      padding: 16px 16px;
                    }
                  }
                }
              }
            }
            .el-textarea {
              padding: 0 28px 24px 16px;
              .el-textarea__inner {
                resize: none;
                height: 116px !important;
                overflow-y: auto;
                border: none;
                background: transparent;
                border-radius: 4px;
                max-height: 116px;
                min-height: 116px !important;
                padding: 0 !important;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 1);
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                width: 572px !important;
                text-align: justify !important;
              }
              .el-input__count {
                background: transparent;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #d1d4dc;
              }
            }
          }
        }
        .textarea-item {
          .el-form-item__content {
            height: 92px !important;
          }
        }
        .textarea-reply {
          height: 239px !important;
          margin-top: 39px;
          .el-form-item__content {
            margin-left: 0 !important;
            height: 100% !important;
            .el-textarea {
              width: 572px !important;
              height: 239px !important;
              padding: 0 28px 24px 16px;
              .el-textarea__inner {
                resize: none;
                height: 239px !important;
                overflow-y: auto;
                border: none;
                background: transparent;
                border-radius: 4px;
                max-height: 239px;
                min-height: 239px !important;
                padding: 0 !important;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 1);
                border-bottom: none;
                width: 572px !important;
                text-align: justify !important;
              }
              .el-input__count {
                background: transparent;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #d1d4dc;
              }
            }
          }
        }
        .textarea-error {
          height: 239px !important;
          margin-top: 39px;
          .el-form-item__content {
            margin-left: 0 !important;
            width: 680px !important;
            height: 239px !important;
            .el-input {
              width: 100% !important;
              height: 239px !important;
              .el-input__inner {
                width: 100% !important;
                height: 239px !important;
                line-height: 239px;
                text-align: center;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 0.7);
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Question.vue